const LINE_WIDTH = 2

class RectangleMark{
    constructor(x, y, width, height) {
        this.x = x
        this.y = y
        this.width = width
        this.height = height

    }

    area() {
        return this.width * this.height
    }

    fix() {
        let rect = this.scale(1)

        if (rect.width < 0) {
            rect.x = rect.x + rect.width
            rect.width = -rect.width
        }

        if (rect.height < 0) {
            rect.y = rect.y + rect.height
            rect.height = -rect.height
        }

        return rect
    }

    scale(factor) {
        let newX = parseInt(this.x * factor)
        let newY = parseInt(this.y * factor)
        let newWidth = parseInt(this.width * factor)
        let newHeight = parseInt(this.height * factor)

        return new RectangleMark(newX, newY, newWidth, newHeight)
    }
}

export default class CanvasImgMark {

    constructor(ctx) {
        this.canvas = ctx.canvas
        this.ctx = ctx
        this.img = null
        this.isClicked = false
        this.firstClickX = 0
        this.firstClickY = 0
        this.currX = 0
        this.currY = 0
        this.color = 'black'
        this.onMarked = () => null
        this.init()
    }

    init() {
        this.canvas.addEventListener("mousemove", (e) => this.move(e), false)
        this.canvas.addEventListener("mousedown", (e) => this.down(e), false)
        this.canvas.addEventListener("mouseup", (e) => this.up(e), false)
        this.canvas.addEventListener("mouseout", (e) => this.out(e), false)
    }

    setImg(img) {
        this.img = img
    }

    draw(color = 'black') {
        this.color = color
        this.ctx.beginPath()
        this.ctx.rect(this.firstClickX, this.firstClickY, this.currX - this.firstClickX, this.currY - this.firstClickY)
        this.ctx.strokeStyle = this.color
        this.ctx.lineWidth = LINE_WIDTH
        this.ctx.stroke()
        this.ctx.closePath()
    }

    redraw(color = 'black') {
        this.erase()
        this.draw(color)
    }

    erase() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
        if (this.img) {
            this.ctx.drawImage(this.img, 0, 0, this.canvas.width, this.canvas.height)
        }
    }

    clean() {
        this.erase()
        this.currY = this.currX = this.firstClickX = this.firstClickY = 0
    }

    out() {
        if (this.isClicked) {
            this.isClicked = false
            this.clean()
        }
    }

    down(e) {
        this.currX = this.getRealCoord(e).x
        this.currY = this.getRealCoord(e).y
        this.firstClickX = this.currX
        this.firstClickY = this.currY
        this.isClicked = true
    }

    up() {
        this.draw('red')
        this.onMarked(new RectangleMark(this.firstClickX, this.firstClickY,
            this.currX - this.firstClickX, this.currY - this.firstClickY))
        this.isClicked = false
    }

    move(e) {
        if (this.isClicked) {
            this.erase()
            let coord = this.getRealCoord(e)
            this.currX = coord.x
            this.currY = coord.y
            this.draw()
        }
    }

    scaleCoords(ratio) {
        if (this.currX && this.currY) {
            this.currX = this.currX * ratio
            this.currY = this.currY * ratio
            this.firstClickX = this.firstClickX * ratio
            this.firstClickY = this.firstClickY * ratio
        }
    }

    redrawWithLastColor() {
        return this.currX && this.currY ? this.redraw(this.color) : null
    }

    getRealCoord(e) {
        let totalOffsetX = 0
        let totalOffsetY = 0
        let canvasX = 0
        let canvasY = 0
        let currentElement = this.canvas

        do {
            totalOffsetX += currentElement.offsetLeft - currentElement.scrollLeft
            totalOffsetY += currentElement.offsetTop - currentElement.scrollTop
        } // eslint-disable-next-line no-cond-assign
        while (currentElement = currentElement.offsetParent)

        canvasX = e.pageX - totalOffsetX
        canvasY = e.pageY - totalOffsetY

        return {x: canvasX, y: canvasY}
    }
}
